import { render, staticRenderFns } from "./ShortVideoFollow.vue?vue&type=template&id=7e9b67ac&scoped=true"
import script from "./ShortVideoFollow.vue?vue&type=script&lang=js"
export * from "./ShortVideoFollow.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoFollow.vue?vue&type=style&index=0&id=7e9b67ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9b67ac",
  null
  
)

export default component.exports